import { render, staticRenderFns } from "./SideMenu2.vue?vue&type=template&id=47d2130c&scoped=true"
import script from "./SideMenu2.vue?vue&type=script&lang=js"
export * from "./SideMenu2.vue?vue&type=script&lang=js"
import style0 from "./SideMenu2.vue?vue&type=style&index=0&id=47d2130c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d2130c",
  null
  
)

export default component.exports